import { css } from 'lit';

export const style = css`
  /** Loan FLow */
  .card-loan-flow {
    background-color: #fff;
    border: 1px solid #d4d4d4;
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    display: block;
    margin: 2em auto;
    padding: 0.5em 1em 1em;
    text-align: center;
  }

  .card-loan-flow > p {
    font-size: 0.875em;
  }

  ul {
    display: flex;
    justify-content: space-evenly;
    list-style-type: none;
    margin: 0 auto 0.75em;
  }

  ul li {
    background-color: #008140;
    border: 3px solid #008140;
    border-radius: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    color: #fff;
    min-width: calc(50% - 1em);
    padding: 0.5em;
    position: relative;
  }

  ul li.negative-value {
    background-color: #f4f4f4;
    border: 1px solid #d4d4d4;
    color: #011829;
  }

  ul li:not(.negative-value)::after {
    content: url('assets/piggy-bank-filled.svg');
    height: 1em;
    position: absolute;
    right: 0.25em;
    top: 0.25em;
    width: 1em;
  }

  ul li p {
    font-weight: 600;
  }

  ul li p:first-of-type {
    font-size: 0.625em;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  ul li p:nth-of-type(2) {
    font-size: 2em;
  }

  ul li p:nth-of-type(2)::first-letter {
    font-size: 0.5em;
    vertical-align: super;
  }

  .savings-tooltip {
    font-size: 0.875em;
    margin-bottom: 1em;
  }

  refi-common-tooltip {
    text-align: left;
  }

  refi-common-tooltip p:not(:last-child) {
    margin-bottom: 1em;
  }

  refi-offer-card-details {
    display: block;
    margin-bottom: 16px;
  }

  .offer-title {
    font-size: 0.875em;
    margin-bottom: 1em;
  }

  .offer-title img {
    height: 17px;
    vertical-align: top;
    width: 80px;
  }

  /** Compare Old Loan */
  .card-compare-old-loan {
    border: 1px solid #d4d4d4;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px 16px 12px 16px;
  }

  .agentGenerated-offer-tooltip-text {
    align-self: stretch;
    color: #fff;
    flex: none;
    flex-grow: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    height: auto;
    order: 0;
    overflow-wrap: normal;
    width: auto;
  }

  .tooltip {
    border-radius: 0;
    width: 18px;
  }

  .grv-tooltip__info-icon-custom:focus .grv-tooltip--top-right,
  .grv-tooltip__info-icon-custom:hover .grv-tooltip--top-right {
    right: -16px;
  }

  .grv-tooltip__info-icon-custom::after {
    background-image: url('assets/blue-info.svg');
    background-position: 50% 50%;
    background-repeat: no-repeat;
    border-bottom: 0 none;
    content: '';
    height: 16px;
    left: 100%;
    margin-left: 4px;
    margin-top: 4px;
    position: absolute;
    width: 16px;
  }

  .grv-tooltip__info-icon-custom:hover::after,
  .grv-tooltip__info-icon-custom:focus::after {
    background-image: url("data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%233D3D3D'%3E%3Cpath d='M12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Zm0,4.25a.75.75,0,1,1-.75.75A.75.75,0,0,1,12,6.25ZM14.5,17H10a.5.5,0,0,1,0-1h2V10H10.5a.5.5,0,0,1,0-1h2a.5.5,0,0,1,.5.5V16h1.5a.5.5,0,0,1,0,1Z'/%3E%3C/svg%3E");
    background-position: 50% 50%;
    background-repeat: no-repeat;
    content: '';
    height: 16px;
    left: 100%;
    position: absolute;
    width: 16px;
  }

  .grv-tooltip {
    border-radius: 6px;
    margin-left: 15px;
    padding: 7px 12px 9px;
    width: 288px;
  }

  span.grv-tooltip__trigger:not(.grv-tooltip__info-icon):not(.grv-tooltip__info-icon--light) {
    border-bottom: 0;
  }

  .tooltip-icon {
    margin-left: 5px;
    margin-top: 3px;
  }

  .no-margin-paragraph {
    line-height: 21px;
    margin-bottom: 0;
    margin-top: 0;
  }

  .select-offer-btn {
    background-color: rgb(2, 118, 177);
    border-radius: 4px;
    font-size: 20px;
    font-weight: 400;
    height: 48px;
    line-height: 30px;
    margin: auto 0;
    width: 100%;
  }
`;
